import { createClient } from '@supabase/supabase-js';

declare const __SUPABASE_URL__: string;
declare const __SUPABASE_ANON_KEY__: string;
declare const __REVIEW__: boolean;

/** Local review mode: no sign-in; requests go through this machine, which adds the key. */
export const REVIEW: boolean = __REVIEW__;

/**
 * What a sign-in link said when it brought the browser back here with an error (expired, already used), read before
 * the client looks at the address: the client keeps that error to its own console and leaves the address as it is.
 */
export const LINK_ERROR: { code: string; description: string } | null = readLinkError();
function readLinkError() {
  if (REVIEW || typeof window === 'undefined') return null;
  const hash = window.location.hash.replace(/^#/, '');
  if (!hash.includes('error')) return null;
  const q = new URLSearchParams(hash);
  const code = q.get('error_code') ?? '';
  const description = q.get('error_description') ?? '';
  return code || description ? { code, description } : null;
}

export const supabase = createClient<any, 'ug'>(
  REVIEW ? `${window.location.origin}/supabase` : __SUPABASE_URL__,
  REVIEW ? 'local-review' : __SUPABASE_ANON_KEY__,
  {
    db: { schema: 'ug' },
    auth: { persistSession: !REVIEW, autoRefreshToken: !REVIEW, detectSessionInUrl: !REVIEW },
  },
);
